<template>
  <v-navigation-drawer v-model="menuDrawer" app width="250" fixed temporary mobile-breakpoint="768">

    <v-list>

      <v-list-tile @click.stop="goto('/')">
        <v-list-tile-title>Home</v-list-tile-title>
      </v-list-tile>

      <v-divider></v-divider>

      <v-list link>

        <!-- menu  -->
        <v-list-tile v-for="(item, i) in menuTestata" @click.stop="goto_2(item)" :key="i">
          <v-list-tile-title v-text="item.descrizione"></v-list-tile-title>
        </v-list-tile>

      </v-list>

      <v-divider></v-divider>

      <v-list-tile @click.stop="esci()">
        <v-list-tile-title>Esci</v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  methods: {
    goto(link, tipo) {
      this.$emit("goto", link, tipo);
    },

    goto_2(item) {
      let dett = this.getMenuDettaglio(item.menuId);
      if (!!dett == false) return;

      this.$emit("goto", dett.programPath, dett.method);
    },

    getMenuDettaglio(menuId) {
      let dett = this.menu.menuDettaglio.find((f) =>
        f.menuIdList.includes("-" + menuId + "-")
      );
      return dett;
    },

    esci() {
      this.$emit("esci");
    }
  },

  computed: {
    menuDrawer: {
      get() {
        return this.$store.getters["app/getDrawerMenu"];
      },
      set(d) {
        this.$store.commit("app/setDrawer", d);
      }
    },

    menu() {
      return this.$store.getters["user/getMenu"];
    },
    menuTestata() {
      return this.menu.menuTestata;
    },
  }
};
</script>